import api from "../../../api/axios";

// Feature-local wrappers for the Client core GET + PATCH used by the
// stale-data tolerance screen (Phase 16).
//
// Endpoints (per backend/app/apps/clients/views.py):
//   GET    /api/crm/clients/{id}/    — IsClientAccessible (owner OR share)
//   PATCH  /api/crm/clients/{id}/    — IsClientWriter (owner OR can_edit share)
//
// Phase 16 only PATCHes `notes` (single-Textarea editor per brief Step 6),
// but the wrapper accepts an arbitrary body — the wrapper is the API
// surface, the widget is the scope gate.
//
// Stateless request wrappers. No cache. No retry. No invalidation. No
// shared ownership. Not a repository, not an entity service, not a
// resource manager — per Phase 16 brief Step 2.

export const fetchClient = (clientId) =>
  api.get(`/crm/clients/${clientId}/`).then((res) => res.data);

export const patchClient = (clientId, body) =>
  api.patch(`/crm/clients/${clientId}/`, body).then((res) => res.data);
